import { http, common } from "@/utilities";
import store from "@/store";
import { VersionTypesEnum } from "@/enums";

const controller = "weather";
export default {
  getWeather: (payload) => {
    let httpOptions = {
      headers: {
        webview: true,
        language: store.state.queryParams.sub.xo,
        // xm: store.state.queryParams.xm,
        // xn: store.state.queryParams.xn,
        // Authorization: store.state.queryParams.Authorization,
        // xx: store.state.queryParams.xx,
        // xc: store.state.queryParams.xc,
        // xb: store.state.queryParams.xb,
      },
    };

    if (store.state.queryParams)
      Object.keys(store.state.queryParams)
        .filter((param) => typeof store.state.queryParams[param] !== "object") // remove 'sub' property
        .forEach((key) => {
          const value = store.state.queryParams[key];
          if (value !== undefined && value !== null && value !== "")
            httpOptions.headers[key] = encodeURIComponent(value);
        });

    if (
      process.env.NODE_ENV === "development" &&
      !store.state.queryParams.xm
      // && !store.state.queryParams.xn
    )
      httpOptions.headers.badesaba = true;

    let url = controller;

    if (store.state.queryParams.xb === VersionTypesEnum.PlayStore)
      url += "/gplay";

    return http.getByParams({ url, params: payload, httpOptions });
  },
};
